import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

import SplitPaymentBar from '../../components/SplitPaymentBar';
import SplitPaymentDot from '../../components/SplitPaymentDot';
import SplitPaymentIcon from '../../../components/Icons/split_payment';
import ChevronIcon from '../../../components/Icons/chevron';
import { Money, HumanPercentage } from '../../../components/Formatters';
import { Dl, Dt, Dd } from '../../../components/DescriptionList/HorizontalTight';
import Tooltip from '../../../components/Tooltip';

import { PayoutSplit } from '../../../types/checkout';
import PayoutDestinationDetails from './PayoutDestinationDetails';


type SplitPaymentRowProps = {
    payoutSplits: PayoutSplit[];
    currency: string;
};

const SplitPaymentRow = ({ payoutSplits, currency }: SplitPaymentRowProps) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const total = payoutSplits.reduce((sum, p) => sum + p.amount, 0);

    return <>
        <SplitRowWrapper onClick={() => { setOpen(!open); }} >
            <Tooltip title={t('payments.fields.split_payment')}><span><SplitPaymentIcon /></span></Tooltip>
            <Spacer />
            <SplitPaymentBar payoutSplits={payoutSplits} currency={currency} />
            <Spacer />
            <ChevronWrapper open={open}>
                <ChevronIcon />
            </ChevronWrapper>
        </SplitRowWrapper>
        {open && <>
            {payoutSplits.map((p, i) => <SplitDestination key={`split-destination-${i}`} >
                <SplitPaymentDot key={i} index={i} />
                <Spacer />
                <SplitDestinationInfo>
                    <Dl>
                        <Dt>{t('payments.fields.split')} {i + 1}</Dt>
                        <Dd>
                            <Money amount={p.amount} currency={currency} boldCurrency /> – <HumanPercentage value={(p.amount / total) * 100} />
                        </Dd>
                        <Spacer />
                        <Dt>{t('payments.fields.payout_destination')}</Dt>
                        <Dd>
                            <PayoutDestinationDetails payout_destination_id={p.payout_destination_id} />
                        </Dd>
                    </Dl>
                </SplitDestinationInfo>
            </SplitDestination>)}
        </>}
    </>;
};

const SplitDestination = styled.div`
    width: 100%;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 16px;
`;

const SplitDestinationInfo = styled.div`
    width: 100%;
    display:flex;
    justify-content: space-between;
    align-items: center;
`;

const SplitRowWrapper = styled.div`
    cursor: pointer;
    width: 100%;
    display:flex;
    justify-content: space-between;
    align-items: center;
`;

const Spacer = styled.div`
    width: 16px;
`;

type OpenProps = {
    open: boolean;
}

const ChevronWrapper = styled.button<OpenProps>`
    border: none;
    background: transparent;
    color: current-color;
    padding: 0;
    margin: 0;
    transition: transform 150ms ease-out;
    cursor: pointer;

    ${props => props.open ? `
        transform: scaleY(-1);
    ` : ''}

    &:focus {
        outline: none;
    }
`;


export default SplitPaymentRow;
